import {CompetitorStatus, ControlPointTime} from "./competitor";

export class CompetitorViewData {
    id?: number;
    registrationId?: number;
    startBlock?: number;
    startNumber?: string;
    startNumberExtension?: string;
    fullName?: string;
    teamName?: string;
    nickname?: string;
    email?: string;
    status?: CompetitorStatus;
    sex?: number;
    mobilePhone?: string;
    raceId?: number;
    raceName?: string;
    paymentStatus?: number;
    country?: string;
    countryShort?: string;
    categoryLabel?: string;
    placeOfResidence?: string;
    address?: string;
    identityCardNumber?: string;
    identityCardExpires?: Date;
    identityCardIssuer?: string;
    club?: string;
    tshirt?: string;
    meal?: string;
    transport?: string;
    comment?: string;
    chipNumber?: string;
    licence?: string;
    emergencyPhone?: string;
    fee?: string;
    discipline?: string;
    nationality?: string;
    bestTime?: string;
    controlPointsTimes?: ControlPointTime[];
    startTime?: Date;
    birthday?: Date;
    created?: Date;
    modified?: Date;
    customFields: Map<string, string> = new Map<string, string>();
    raceAdditionalItems: Map<string, string> = new Map<string, string>();
    raceCommercialItemValue?: string;
    teamMembers?: CompetitorViewData[];

}